import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Shop from '../widgets/shop/Shop';
import NewArrivalsPanel from '../widgets/shop/NewArrivalsPanel';
import TopSellersPanel from '../widgets/shop/TopSellersPanel';
import ConfigContext from '../../contexts/ConfigContext';
import ItemDetailsPage from './ItemDetailsPage';

const Store = () => {
  const {config} = useContext(ConfigContext);
  const showInventoryWarning = config.general?.show_inventory_warning || false;
  // Detect which "highlight" landing page we're on by URL substring.
  // We deliberately read the pathname directly (rather than using
  // useRouteMatch) because Store is mounted via different Routes
  // depending on whether the URL is `/new-arrivals` or
  // `/new-arrivals/item/<id>`, and useRouteMatch's behaviour under the
  // background-location modal pattern was unreliable enough to flip
  // Store back to Shop when the dialog opened.
  const { pathname } = useLocation();
  const inNewArrivals = /\/r\/[^/]+\/new-arrivals(\/|$)/.test(pathname);
  const inBestSellers = /\/r\/[^/]+\/best-sellers(\/|$)/.test(pathname);
  const inHotSellers = /\/r\/[^/]+\/hot-sellers(\/|$)/.test(pathname);

  return (
    <>
      <ItemDetailsPage />
      {showInventoryWarning && (
        <div id="doing-inventory">
          <div id='doing-inventory-title'>We're doing inventory!</div>
          <div id='doing-inventory-body'>
            We are currently doing the yearly inventory, which means that ALL items are being removed from the site and will be added back
            as they are counted. Sorry for the inconvenience. If you do not
            see something you want, please give us a call, or check back later. More items will be added each (work) day.
          </div>
        </div>
      )}

      <div className="store-parent">
        <div className="store-main">
          {inNewArrivals ? (
            <NewArrivalsPanel />
          ) : inBestSellers ? (
            <TopSellersPanel mode="best-sellers" />
          ) : inHotSellers ? (
            <TopSellersPanel mode="hot-sellers" />
          ) : (
            <Shop />
          )}
        </div>
      </div>
    </>
  )
}

export default Store
